// import SwiperGalleries from './SwiperGallery';
import * as Menu                    from "./Menu";
window.$ = window.jQuery = require('jquery');

const AjaxLoadPage = function() {
    const _body = $('body');
    const _header = $('#header');
    const _introLayer = $("#layerIntroPage");
    const _logoMu = $("#load-logo-mu");
    const _logoVa = $("#load-logo-va");
    const _webdoorMotion = $("#webdoor-motion");

    const pageLoader = function() {

        setTimeout(() => {


            _introLayer.addClass('motion-in ');


            setTimeout(() => {
                _logoMu.addClass('motion-in');
                _logoVa.addClass('motion-in');
            }, 1500);

            setTimeout(() => {
                _introLayer.addClass('motion-out');

                // INICIA
                setTimeout(() => {
                    Menu.init();
                    _body.removeClass('scroll-off body-content-loading');
                    _header.addClass('motion-in');
                }, 500)

                setTimeout(() => {
                    _webdoorMotion.addClass('motion-in');
                }, 1000);
            }, 2800);



        }, _timerSync);

    }


    return {
        init: function(status) {

            pageLoader(status);
            /* $('a[href]').not('.no-load').on('click', (e) => {
                e.preventDefault();
                _introLayer.removeClass('motion-out');
                // _introLayer.addClass('motion-in');
                setTimeout(() => {
                    window.location.href = e.currentTarget.getAttribute('href');
                }, 1000)
            }); */

        }
    }

}();

export default AjaxLoadPage;